import React, { useState, useEffect, useMemo } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import styles from './RepoEntry.module.css'; // Import the CSS module
import { FileContent } from './FileContent.js'; // Adjust path as needed
import Header from '../components/Header';
import ContactFooter from '../components/ContactFooter';


// --- SVG Icons (Unchanged) ---
const BackIcon = () => ( <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg> );
const RepoIcon = () => ( <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg> );
const CommitIcon = () => ( <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor"><path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm5.5-1.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3zM8 9.5a.5.5 0 0 0 0-1H6.5a.5.5 0 0 0 0 1H8zm2.5-1.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3z"/></svg> );
const BranchIcon = () => ( <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor"><path fillRule="evenodd" d="M11.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM5.5 3.5A1.5 1.5 0 1 1 2.5 5h6.128a2.5 2.5 0 0 1 1.92 4.04L9.12 13H12.5A1.5 1.5 0 0 1 14 11.5v-3a1.5 1.5 0 0 1-3 0V7a.5.5 0 0 0-1 0v1.5a.5.5 0 0 0 .5.5H11a.5.5 0 0 0 0-1H9.628a1.5 1.5 0 0 0-1.152-2.424L6.96 4.04A2.5 2.5 0 0 1 8.882 3H12.5A1.5 1.5 0 0 1 11 1.5a.5.5 0 0 0 0-1A2.5 2.5 0 0 0 8.5 3H5.5A2.5 2.5 0 0 0 3 5.5v3A2.5 2.5 0 0 0 5.5 11h.372a1.5 1.5 0 0 0 1.152 2.424l1.516 1.011A2.5 2.5 0 0 1 6.118 16H2.5A2.5 2.5 0 0 1 0 13.5v-3A2.5 2.5 0 0 1 2.5 8h1.128a2.5 2.5 0 0 1 1.92-4.04L6.96 1.457A2.5 2.5 0 0 1 8.882 0H12.5a2.5 2.5 0 0 1 2.5 2.5v3A2.5 2.5 0 0 1 12.5 8h-1.128a2.5 2.5 0 0 1-1.92 4.04l-1.516 1.011A2.5 2.5 0 0 1 6.118 15H2.5a.5.5 0 0 0 0 1h3.618a1.5 1.5 0 0 0 1.152-2.424L8.786 12.54A1.5 1.5 0 0 0 7.634 10H5.5a1.5 1.5 0 0 1 0-3h1.372a1.5 1.5 0 0 0 1.152-2.424L6.509 3.566A1.5 1.5 0 0 0 5.357 2H2.5a.5.5 0 0 0 0 1H5.5A1.5 1.5 0 0 1 7 4.5v3A1.5 1.5 0 0 1 5.5 9H4.128A1.5 1.5 0 0 0 2.976 6.576L4.49 5.566A1.5 1.5 0 0 0 3.338 3H2.5a1.5 1.5 0 0 1-1.5-1.5V1a.5.5 0 0 0-1 0v.5A2.5 2.5 0 0 0 2.5 4h.872a1.5 1.5 0 0 0-1.152 2.424L.705 7.434A2.5 2.5 0 0 1 1.857 10h.643a.5.5 0 0 0 0-1H2.5a1.5 1.5 0 0 1-1.5-1.5v-3A1.5 1.5 0 0 1 2.5 4h.838a2.5 2.5 0 0 1 1.92 4.04L3.84 9.051A2.5 2.5 0 0 1 1.92 12H1a.5.5 0 0 0 0 1h.92a1.5 1.5 0 0 0 1.152-2.424l1.516-1.011A1.5 1.5 0 0 0 5.734 8H8.5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-3 0V11a.5.5 0 0 0-1 0v1.5a2.5 2.5 0 0 0 5 0v-3A2.5 2.5 0 0 0 8.5 7H7.128a1.5 1.5 0 0 0-1.152 2.424L7.49 10.434A1.5 1.5 0 0 0 8.643 12H11.5a.5.5 0 0 0 0-1H9.128a2.5 2.5 0 0 1-1.92-4.04L8.624 5.95A1.5 1.5 0 0 0 7.472 4H5.5A2.5 2.5 0 0 0 3 6.5v3A2.5 2.5 0 0 0 5.5 12h.618a2.5 2.5 0 0 1 1.92 4.04l1.516 1.011A1.5 1.5 0 0 0 10.707 16H11.5a.5.5 0 0 0 0-1h-.793a.5.5 0 0 1-.384-.811L11.84 13.18A1.5 1.5 0 0 0 12.5 12H14a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H12.5a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V8.5A1.5 1.5 0 0 1 14 7v3a.5.5 0 0 0 .5.5H15a.5.5 0 0 0 0-1h-.5a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 12.5 5H8.882a.5.5 0 0 1-.384-.811L9.96 2.18A1.5 1.5 0 0 0 10.5 2H11.5a.5.5 0 0 0 0-1z"/></svg> );
const DownloadIcon = () => ( <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg> );
const FolderIcon = () => ( <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor"><path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM6.172 2.5a1 1 0 0 0-.707.293L4.634 3.63a1 1 0 0 1-.707.293H2.5a1 1 0 0 0-1 .981l.006.139C1.72 4.03 1.95 4 2.19 4h5.396l-.707-.707A1 1 0 0 0 6.172 2.5z"/></svg> );
const FileIcon = () => ( <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor"><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/></svg> );

// --- Helper Functions (Unchanged) ---
const formatRepoName = (repo) => repo.replace('.git', '').replace(/_/g, ' ');
const shortenHash = (hash) => hash.substring(0, 7);
const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
const parseBranch = (branchString) => {
    const isActive = branchString.startsWith('*');
    const name = branchString.replace('*', '').trim().split(/\s+/)[0];
    return { name, isActive };
};

// --- Child Components ---

const RepoHeader = ({ repoName }) => (
    <header className={styles.repoHeader}>
        <div className={styles.repoTitleSection}>
            <Link to="/repos" className={styles.repoAvatar}><RepoIcon /></Link>
            <h1 className={styles.repoTitle}>{formatRepoName(repoName)}</h1>
        </div>
    </header>
);

const RepoControls = ({ branches, selectedBranch, onBranchChange, cloneUrl, isLoading, repoName }) => {
    const handleDownloadZip = () => {
        const downloadUrl = `https://dev.entrosystem.com/api/repos_api/${repoName}/zip${selectedBranch ? `?branch=${selectedBranch}` : ''}`;
        // Create a temporary link element to trigger download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${formatRepoName(repoName)}-${selectedBranch || 'main'}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className={styles.repoControls}>
            <div className={styles.branchSelector}>
                <BranchIcon />
                <select value={selectedBranch || ''} onChange={onBranchChange} disabled={isLoading}>
                    {branches.map((branchString, i) => {
                        const branch = parseBranch(branchString);
                        return <option key={i} value={branch.name}>{branch.name}</option>;
                    })}
                </select>
            </div>
            <button
                className={styles.downloadButton}
                onClick={handleDownloadZip}
                disabled={isLoading}
                title={`Download ${formatRepoName(repoName)} as ZIP`}
            >
                <DownloadIcon />
                Download ZIP
            </button>
        </div>
    );
};


const FileExplorer = ({ repoName, treeData, currentPath, onPathChange, onGoUp, isLoading, onFileSelect }) => { // <-- Add onFileSelect prop
    // This complex calculation is memoized to prevent re-running on every render.
    // It processes the flat list of files from the API into a browsable directory view.
    const currentExplorerView = useMemo(() => {
        if (!treeData.length) return { folders: [], files: [] };

        const directChildren = new Map();
        const folderSet = new Set();
        const currentPathPrefix = currentPath ? `${currentPath}/` : '';

        for (const item of treeData) {
            if (item.path.startsWith(currentPathPrefix)) {
                const relativePath = item.path.substring(currentPathPrefix.length);
                const pathSegments = relativePath.split('/');

                if (pathSegments.length === 1 && relativePath !== '') { // File in current directory
                    directChildren.set(relativePath, { name: relativePath, size: item.size, type: 'file' });
                } else if (pathSegments.length > 1) { // Item in a subdirectory
                    const folderName = pathSegments[0];
                    if (!folderSet.has(folderName)) {
                        folderSet.add(folderName);
                        directChildren.set(folderName, { name: folderName, type: 'folder' });
                    }
                }
            }
        }
        
        const childrenArray = Array.from(directChildren.values());
        return {
            folders: childrenArray.filter(c => c.type === 'folder').sort((a, b) => a.name.localeCompare(b.name)),
            files: childrenArray.filter(c => c.type === 'file').sort((a, b) => a.name.localeCompare(b.name)),
        };
    }, [treeData, currentPath]);
    
    const pathSegments = currentPath.split('/').filter(Boolean);

    return (
        <div className={styles.fileExplorer}>
            <div className={styles.fileExplorerHeader}>
                <p className={styles.currentPath}>
                    <button onClick={() => onPathChange('')}>{formatRepoName(repoName)}</button>
                    {pathSegments.map((segment, index) => {
                        const pathOnClick = pathSegments.slice(0, index + 1).join('/');
                        return <span key={segment}> / <button onClick={() => onPathChange(pathOnClick)}>{segment}</button></span>;
                    })}
                </p>
            </div>
            {isLoading ? (
                <div className={`${styles.loadingSpinner} ${styles.small}`}><div className={styles.spinner}></div><p>Loading files...</p></div>
            ) : (
                <div className={styles.fileList}>
                    {currentPath && (
                        <div className={`${styles.fileRow} ${styles.interactive}`} onClick={onGoUp}>
                            <div className={styles.fileIcon}><FolderIcon /></div>
                            <div className={styles.fileName}>..</div>
                        </div>
                    )}
                    {currentExplorerView.folders.map(folder => (
                        <div key={folder.name} className={`${styles.fileRow} ${styles.interactive}`} onClick={() => onPathChange(currentPath ? `${currentPath}/${folder.name}` : folder.name)}>
                            <div className={styles.fileIcon}><FolderIcon /></div>
                            <div className={styles.fileName}>{folder.name}</div>
                        </div>
                    ))}
                    {currentExplorerView.files.map(file => (
                        <div key={file.name} className={`${styles.fileRow} ${styles.interactive}`} onClick={() => onFileSelect(currentPath ? `${currentPath}/${file.name}` : file.name)}>
                        {/* <div key={file.name} className={styles.fileRow}> */}
                            <div className={styles.fileIcon}><FileIcon /></div>
                            <div className={styles.fileName}>{file.name}</div>
                            <div className={styles.fileSize}>{formatFileSize(file.size)}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

// const CommitList = ({ commits }) => (
//     <div className={styles.commitList}>
//         {commits.map((commit) => (
//             <div key={commit.commit} className={styles.commitItem}>
//                 <div className={styles.commitDetails}>
//                     <p className={styles.commitSubject}>{commit.subject}</p>
//                     <div className={styles.commitMeta}>
//                         <span className={styles.commitAuthor}>{commit.author}</span> committed <span className="commit-date">{commit.date}</span>
//                     </div>
//                 </div>
//                 <div className={styles.commitHashWrapper}>
//                     <span className="commit-hash">{shortenHash(commit.commit)}</span>
//                 </div>
//             </div>
//         ))}
//     </div>
// );

// --- Main Component ---
function RepoEntry() {

    const bannerImageUrl = "/images/BannerPage1.jpg";


    const { repoName, '*': initialPath = '' } = useParams();
    const navigate = useNavigate();
    
    const [repoData, setRepoData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const [activeTab, setActiveTab] = useState('code');
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [treeData, setTreeData] = useState([]);
    const [currentPath, setCurrentPath] = useState('');
    const [loadingTree, setLoadingTree] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);
    const [hasProcessedInitialPath, setHasProcessedInitialPath] = useState(false);
    const [isUrlSpecifiedFile, setIsUrlSpecifiedFile] = useState(false);

    useEffect(() => {
        setLoading(true);
        setError(null);
        fetch(`https://dev.entrosystem.com/api/repos_api/${repoName}/details`)
            .then(response => {
                if (!response.ok) throw new Error(`Repository details not found (Status: ${response.status})`);
                return response.json();
            })
            .then(data => {
                setRepoData(data);
                const defaultBranch = data.branches.find(b => b.startsWith('*'));
                const branchName = defaultBranch ? parseBranch(defaultBranch).name : parseBranch(data.branches[0]).name;
                setSelectedBranch(branchName);
            })
            .catch(error => setError(error.message))
            .finally(() => setLoading(false));
    }, [repoName]);


    useEffect(() => {
        if (!selectedBranch) return;

        setLoadingTree(true);
        fetch(`https://dev.entrosystem.com/api/repos_api/${repoName}/tree/${selectedBranch}?recursive=true`)
            .then(response => {
                if (!response.ok) throw new Error(`File tree for branch '${selectedBranch}' not found (Status: ${response.status})`);
                return response.json();
            })
            .then(data => {
                setTreeData(data);
                setHasProcessedInitialPath(false); // Reset flag to process URL path
            })
            .catch(error => {
                setError(error.message);
                setTreeData([]);
            })
            .finally(() => setLoadingTree(false));
    }, [repoName, selectedBranch]);
    
    // Handle initial path from URL after tree data is loaded
    useEffect(() => {
        if (!treeData.length || loadingTree || hasProcessedInitialPath) return;

        if (initialPath) {
            // Decode URL to handle spaces and special characters
            const decodedPath = decodeURIComponent(initialPath);
            
            // Check if the path looks like a file (has an extension)
            const pathSegments = decodedPath.split('/');
            const lastSegment = pathSegments[pathSegments.length - 1];
            const hasFileExtension = lastSegment.includes('.') && !lastSegment.startsWith('.');
            
            if (hasFileExtension) {
                // This looks like a file path
                const directoryPath = pathSegments.slice(0, -1).join('/');
                setCurrentPath(directoryPath);
                setSelectedFile(decodedPath);
                setIsUrlSpecifiedFile(true);
            } else {
                // This is a directory path
                setCurrentPath(decodedPath);
                setIsUrlSpecifiedFile(false);
                // Let the README selection effect handle file selection
            }
        } else {
            setIsUrlSpecifiedFile(false);
        }
        
        setHasProcessedInitialPath(true);
    }, [treeData, loadingTree, initialPath, hasProcessedInitialPath]);
    
    // Automatically select README when navigating into a new folder
    useEffect(() => {
        if (!treeData.length || loadingTree || !hasProcessedInitialPath) return;
        
        // Skip auto-selection if we have a specific file selected from URL
        if (isUrlSpecifiedFile) return;

        const currentPathPrefix = currentPath ? `${currentPath}/` : '';
        let readmeInCurrentPath = treeData.find(item => 
            item.path.toLowerCase() === `${currentPathPrefix}readme.md`
        );
        if (!readmeInCurrentPath) {
            // If no README.md, find the first .md file in the current path
            readmeInCurrentPath = treeData.find(item => {
                const path = item.path.toLowerCase();
                return path.startsWith(currentPathPrefix) &&
                    path.slice(currentPathPrefix.length).indexOf('/') === -1 && // only direct children
                    path.endsWith('.md');
            });
        }

        if (readmeInCurrentPath) {
            setSelectedFile(readmeInCurrentPath.path);
        } else {
            setSelectedFile(null);
        }

    }, [currentPath, treeData, loadingTree, hasProcessedInitialPath, isUrlSpecifiedFile]);


    const handlePathChange = (newPath) => {
        setCurrentPath(newPath);
        setSelectedFile(null); // Clear selected file when changing directory
        setIsUrlSpecifiedFile(false); // Reset URL file flag when manually navigating
        
        // Update URL to reflect the new path
        const targetPath = newPath ? `/${encodeURIComponent(newPath)}` : '';
        navigate(`/repo-entry/${repoName}${targetPath}`, { replace: true });
    };

    const handleFileSelect = (filePath) => {
        setSelectedFile(filePath);
        setIsUrlSpecifiedFile(false); // Reset URL file flag when manually selecting
        
        // Update URL to include the file path
        const targetPath = `/${encodeURIComponent(filePath)}`;
        navigate(`/repo-entry/${repoName}${targetPath}`, { replace: true });
    };






    const handleGoUp = () => {
        const pathSegments = currentPath.split('/').filter(Boolean);
        pathSegments.pop();
        handlePathChange(pathSegments.join('/')); // Use handlePathChange to trigger effects
        // setCurrentPath(pathSegments.join('/'));
    };

    if (loading) {
        return <div className={styles.repoEntryContainer}><div className={styles.loadingSpinner}><div className={styles.spinner}></div><p>Loading Repository...</p></div></div>;
    }
    if (error && !repoData) {
        return <div className={styles.repoEntryContainer}><div className={styles.errorContainer}><h2>Failed to Load Repository</h2><p>{error}</p><Link to="/repos" className={styles.backButton}>Back to Repositories</Link></div></div>;
    }
    if (!repoData) return null;

    const cloneUrl = `https://dev.entrosystem.com/git/${repoName}`;

    return (
        <div>
            <Header backgroundImageUrl={bannerImageUrl} subtitle={"Transparency and collaboration build the modern world."} />
            
            <div className={styles.repoEntryContainer}>
                <RepoHeader repoName={repoName} />

                <main className={styles.repoContent}>
                    <RepoControls
                        branches={repoData.branches}
                        selectedBranch={selectedBranch}
                        onBranchChange={(e) => setSelectedBranch(e.target.value)}
                        cloneUrl={cloneUrl}
                        isLoading={loadingTree}
                        repoName={repoName}
                    />
                    
                    <div className={styles.repoDetailsContent}>
                        {/* <nav className={styles.tabs}> */}
                            {/* <button className={`${styles.tabButton} ${activeTab === 'code' ? styles.active : ''}`} onClick={() => setActiveTab('code')}>Code</button> */}
                            {/* <button className={`${styles.tabButton} ${activeTab === 'commits' ? styles.active : ''}`} onClick={() => setActiveTab('commits')}>Commits ({repoData.commits?.length || 0})</button> */}
                        {/* </nav> */}

                        <div className={styles.tabContent}>
                            {/* {activeTab === 'code' && ( */}
                                <>
                                    <FileExplorer 
                                        repoName={repoName}
                                        treeData={treeData}
                                        currentPath={currentPath}
                                        onPathChange={handlePathChange}
                                        onGoUp={handleGoUp}
                                        isLoading={loadingTree}
                                        onFileSelect={handleFileSelect} // Pass the file selection handler
                                    />
                                    <FileContent // The new component
                                        repoName={repoName}
                                        branch={selectedBranch}
                                        filePath={selectedFile}
                                    />
                                </>
                            {/* // )} */}
                            {/* {activeTab === 'commits' && (
                                <CommitList commits={repoData.commits} />
                            )} */}
                        </div>
                    </div>
                </main>
            </div>


            <ContactFooter 
                title="Contact"
                description="Feel free to reach out for collaborations, consultations, or discussions on AI and related fields."
                copyrightText="© 2025 Entrosystem. All innovative rights reserved."
                backgroundImageUrl={bannerImageUrl}
            />
        </div>
    );
}


export default RepoEntry;